export const LINK_BASIC = 'basic'

export const LINK_UNDERLINE = 'underline'

export const LINK_SECONDARY = 'secondary'
